<div class="flex items-center justify-center w-full min-h-full">
  <app-promotion-content></app-promotion-content>
  <div
    class="basis-1/2 grow shrink-0 py-8 px-4 flex flex-col items-center justify-center gap-10"
  >
    <div class="flex flex-col gap-6 w-full max-w-96">
      <app-logo class="tablet:hidden desktop:hidden"></app-logo>
      <div class="flex flex-col items-start gap-2">
        <h1 class="text-2xl font-semibold">
          {{ 'Reset password' | locale }}
        </h1>
        <p class="text-gray-500">
          {{ 'Please enter a new password' | locale }}
        </p>
      </div>
    </div>

    <form class="flex flex-col gap-4 w-full max-w-96" [formGroup]="form">
      <app-input
        [label]="'New password'"
        [autocomplete]="'new-password'"
        [isRequired]="true"
        [type]="'password'"
        [formControl]="form.controls.password"
        [errorMessage]="form.controls.password.errors?.['error']"
      />
      <small class="text-sm text-gray-500">{{
        'Must be at least 8 characters' | locale
      }}</small>
      <app-button
        [buttonStyleClass]="'w-full'"
        (click)="updatePassword()"
        [disabled]="updatingPassword()"
      >
        Reset Password
      </app-button>
    </form>
  </div>
</div>
